import React from 'react';

const ModalCompany = params => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h32v32H-2z" />
      <path
        fill={params.color || '#108EE9'}
        fillRule="nonzero"
        d="M27.333 19c0-.92-.746-1.667-1.666-1.667h-1.111a.278.278 0 0 1-.278-.277v-1.39a1.947 1.947 0 0 0-1.945-1.944h-5.555a.278.278 0 0 1-.278-.278v-2.5c0-.154.125-.277.278-.277H19c.92 0 1.667-.747 1.667-1.667V2.333c0-.92-.747-1.666-1.667-1.666h-7.778c-.92 0-1.666.746-1.666 1.666V9c0 .92.746 1.667 1.666 1.667h3.334c.153 0 .277.124.277.277v2.5a.278.278 0 0 1-.277.278h-8.89a1.947 1.947 0 0 0-1.944 1.945v1.389a.278.278 0 0 1-.278.277h-1.11c-.921 0-1.667.747-1.667 1.667v6.667c0 .92.746 1.666 1.666 1.666h7.778c.92 0 1.667-.746 1.667-1.666V19c0-.92-.746-1.667-1.667-1.667H5.667a.278.278 0 0 1-.278-.277v-1.39a.281.281 0 0 1 .278-.277h16.666a.281.281 0 0 1 .278.278v1.389a.278.278 0 0 1-.278.277H17.89A1.667 1.667 0 0 0 16.222 19v6.667c0 .92.746 1.666 1.667 1.666h7.778c.92 0 1.666-.746 1.666-1.666V19zM13.444 5.388a.833.833 0 1 1 0-1.667h3.334a.833.833 0 0 1 0 1.667h-3.334zm-8.888 15h3.333a.833.833 0 0 1 0 1.666H4.556a.833.833 0 0 1 0-1.666zm18.888 0a.833.833 0 0 1 0 1.666h-3.333a.833.833 0 0 1 0-1.666h3.333z"
      />
    </g>
  </svg>
);

export default ModalCompany;
